export const getInternalIconStyles = (size: string, isStandalone?: boolean) => {
  let iconDimension = '24';

  if (size === 'xs') {
    if (isStandalone) {
      iconDimension = '16';
    } else {
      iconDimension = '1.25rem';
    }
  }

  if (size === 'sm') {
    iconDimension = '1.25rem';
  }

  return {
    '& svg': {
      height: iconDimension,
      width: iconDimension,
    },
  };
};
